if (!customElements.get('compatible-products')) {
  customElements.define(
    'compatible-products',
    class CompatibleProducts extends HTMLElement {
      connectedCallback() {
        this.toggles = this.querySelectorAll('.compatible-products__toggle');
        this.toggles.forEach((toggle) => toggle.addEventListener('click', () => this.expand(toggle)));
      }

      expand(toggle) {
        this.setAttribute('expanded', '');
        this.toggles.forEach((button) => button.setAttribute('aria-expanded', 'true'));
        this.querySelector(`${toggle.dataset.overflow} a`)?.focus();
      }
    }
  );
}
